export const styles = {
  chatContainer: {
    display: 'flex',
    height: 'calc(100vh - 80px)',
    minHeight: '500px',
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
    margin: '0',
    position: 'relative',
  },
  conversacionesPanel: {
    width: '320px',
    minWidth: '280px',
    maxWidth: '350px',
    borderRight: '1px solid var(--agx-border)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--agx-surface)',
    height: '100%',
    overflow: 'hidden',
  },
  chatHeader: {
    padding: '16px',
    borderBottom: '1px solid var(--agx-border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  },
  searchContainer: {
    padding: '12px 16px',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  searchIcon: {
    position: 'absolute',
    left: '28px',
    top: '21px',
    color: 'var(--agx-faint)',
  },
  searchInput: {
    width: '100%',
    padding: '10px 12px 10px 36px',
    border: '1px solid var(--agx-border)',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: 'var(--agx-input-bg)',
    color: 'var(--agx-text)',
  },
  conversacionesList: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  conversacionItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    gap: '12px',
    position: 'relative',
    minHeight: '72px',
  },
  conversacionInfo: {
    flex: 1,
    minWidth: 0,
  },
  conversacionNombre: {
    fontSize: '15px',
    fontWeight: '500',
    marginBottom: '4px',
    color: 'var(--agx-text)',
  },
  conversacionMensaje: {
    fontSize: '13px',
    color: 'var(--agx-muted)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  conversacionHora: {
    fontSize: '11px',
    color: 'var(--agx-faint)',
    flexShrink: 0,
  },
  chatActivoPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--agx-bg2)',
    height: '100%',
    overflow: 'hidden',
    minWidth: 0,
  },
  chatActivoHeader: {
    padding: '12px 20px',
    backgroundColor: 'var(--agx-surface)',
    borderBottom: '1px solid var(--agx-border)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexShrink: 0,
  },
  backButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  chatActivoInfo: {
    flex: 1,
  },
  chatActivoNombre: {
    fontSize: '16px',
    fontWeight: '500',
    color: 'var(--agx-text)',
  },
  chatActivoEstado: {
    fontSize: '12px',
    color: 'var(--agx-green)',
  },
  headerActions: {
    display: 'flex',
    gap: '8px',
  },
  headerIconBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--agx-muted)',
  },
  mensajesArea: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minHeight: 0,
  },
  dateSeparator: {
    display: 'flex',
    justifyContent: 'center',
    margin: '14px 0 10px',
  },
  dateChip: {
    fontSize: '11px',
    color: 'var(--agx-muted)',
    backgroundColor: 'var(--agx-skeleton)',
    padding: '3px 12px',
    borderRadius: '12px',
    fontWeight: 600,
    boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  },
  inputArea: {
    padding: '12px 20px',
    backgroundColor: 'var(--agx-surface)',
    borderTop: '1px solid var(--agx-border)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
  },
  inputButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-muted)',
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageInput: {
    flex: 1,
    padding: '10px 16px',
    border: '1px solid var(--agx-border)',
    borderRadius: '24px',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: 'var(--agx-input-bg)',
    color: 'var(--agx-text)',
  },
  sendButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-pri2)',
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noChatSelected: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    color: 'var(--agx-muted)',
    backgroundColor: 'var(--agx-bg2)',
  },
  noChatIcon: {
    fontSize: '64px',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px',
    color: 'var(--agx-faint)',
  },
  emptyChatState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: 'var(--agx-faint)',
  },
  emptyChatIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  emptyChatSub: {
    fontSize: '12px',
    marginTop: '8px',
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    color: 'var(--agx-muted)',
  },
  infoPanel: {
    width: '300px',
    backgroundColor: 'var(--agx-surface)',
    borderLeft: '1px solid var(--agx-border)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
  },
  infoHeader: {
    padding: '16px 20px',
    borderBottom: '1px solid var(--agx-border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  },
  closeInfoBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color: 'var(--agx-muted)',
  },
  infoContent: {
    padding: '24px',
    textAlign: 'center',
    overflow: 'auto',
  },
  infoAvatar: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: 'var(--agx-pri2)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    margin: '0 auto 16px',
  },
  infoName: {
    marginBottom: '20px',
    color: 'var(--agx-text)',
  },
  infoDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid var(--agx-border)',
    fontSize: '13px',
  },
  infoLabel: {
    fontWeight: '500',
    color: 'var(--agx-muted)',
  },
  infoActions: {
    marginTop: '24px',
    display: 'flex',
    gap: '12px',
  },
  infoActionBtn: {
    flex: 1,
    padding: '8px',
    backgroundColor: 'var(--agx-blue-bg)',
    color: 'var(--agx-pri2)',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  iconButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-muted)',
  },
  mensaje: {
    display: 'flex',
  },
  mensajeBubble: {
    maxWidth: '65%',
    padding: '7px 11px',
    position: 'relative',
    boxShadow: '0 1px 1px rgba(0,0,0,0.12)',
    animation: 'agxMsgIn 0.18s ease',
  },
  botLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: 'var(--agx-muted)',
    marginBottom: '4px',
  },
  mensajeTexto: {
    fontSize: '14px',
    wordWrap: 'break-word',
    lineHeight: '1.4',
  },
  mensajeFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    marginTop: '4px',
  },
  mensajeHora: {
    fontSize: '10px',
    color: 'var(--agx-faint)',
  },
  mensajeCheck: {
    fontSize: '10px',
    color: 'var(--agx-faint)',
  },
  mensajeNoLeido: {
    fontSize: '10px',
    color: 'var(--agx-red)',
  },
  msgAnim: `
    @keyframes agxMsgIn {
      from { opacity: 0; transform: translateY(8px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `,
};
